import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { PhxCellBase } from './phx-cell-base';

@Component({
  selector: 'td[phx-table-cell], th[phx-table-cell]',
  templateUrl: './phx-table-cell.component.html',
  styleUrls: ['./phx-table-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-table-cell',
    '[class.phx-table-cell-align-center]': 'phxAlign === "center"',
    '[class.phx-table-cell-align-right]': 'phxAlign === "right"',
    '[class.phx-table-cell-valign-top]': 'phxVerticalAlign === "top"',
    '[class.phx-table-cell-valign-bottom]': 'phxVerticalAlign === "bottom"',
    '[class.phx-table-cell-valign-middle]': 'phxVerticalAlign === "middle"',
    '[class.phx-table-cell-border-left]': 'phxBorderLeft',
    '[class.phx-table-cell-border-right]': 'phxBorderRight',
    '[class.phx-table-cell-highlight]': 'phxHighlightBorder',
    '[class.phx-table-cell-highlight-positive]': 'phxHighlightBorder && phxHighlightIntent === "positive"',
    '[class.phx-table-cell-highlight-negative]': 'phxHighlightBorder && phxHighlightIntent === "negative"',
    '[class.phx-table-cell-highlight-caution]': 'phxHighlightBorder && phxHighlightIntent === "caution"',
    '[class.phx-table-cell-highlight-warning]': 'phxHighlightBorder && phxHighlightIntent === "warning"',
    '[class.phx-table-cell-highlight-accent]': 'phxHighlightBorder && phxHighlightIntent === "accent"',
    '[class.phx-table-cell-loading]': 'phxLoading',
    '[attr.colspan]': 'phxColspan',
    '[attr.rowspan]': 'phxRowspan',
  },
})
export class PhxTableCellComponent extends PhxCellBase {}
